import { AbstractControl, ValidatorFn } from '@angular/forms';
import { AtsRegex } from '@ats/utility';

/**
 * Validator that checks if the field value is not exclusively composed of any of the provided strings. This is CASE SENSITIVE
 * @param args Characters that the field value cannot exclusively consist of
 */
export function singleStringExclusiveExclusionValidator(...args: string[]): ValidatorFn {
	return (control: AbstractControl) => {
		const controlValue: string = control.value?.replace(AtsRegex.WHITESPACE, '')?.trim();
		if (!controlValue) {
			return null;
		}
		let passes = true;

		args.forEach(exclusionVal => {
			if (!passes || !exclusionVal) {
				return;
			}
			passes = !controlValue.split('').every(c => c === exclusionVal);
		});

		return !passes ? { singleStringExclusiveExclusion: true } : null;
	};
}
